import React from "react";

const AlertPop = ({ variant, children }) => {

  return (
      <div className={`alert alert-${variant} alert-pop`}>
          {children}
      </div>
    )
};

export default AlertPop;
